import { Injectable } from '@angular/core';
import { WilsonState } from '@wilson/non-domain-specific/decorators/wilson-state';
import { Observable, Subject } from 'rxjs';

@Injectable()
export class UnassignedRegionCellViewShiftsDetailsRenderService {
  @WilsonState<boolean>(false)
  showShiftValidation!: boolean;
  readonly showShiftValidation$!: Observable<boolean>;

  readonly visibleShiftIdsSubject!: Subject<
    {
      shiftId: string;
      isVisible: boolean;
    }[]
  >;

  constructor() {
    this.visibleShiftIdsSubject = new Subject();
  }
}
